module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container home-content-box"
  }, [_c('div', {
    staticClass: "col-lg-offset-1 col-lg-10"
  }, [_c('ol', {
    staticClass: "row",
    attrs: {
      "id": "company-infos"
    }
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "col-md-7 col-sm-7 col-xs-12 company-txt"
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$t("home.company_profile")) + "\n          ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("common.more")))])])]), _vm._v(" "), _c('div', {
    staticClass: "cutting-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "health-help"
  }, [_c('h4', {
    staticClass: "title-md"
  }, [_c('a', {
    attrs: {
      "href": "###"
    }
  }, [_vm._v(_vm._s(_vm.$t("home.health_intervention"))), _c('em', [_vm._v("Health Intervention")])])]), _vm._v(" "), _c('ol', {
    staticClass: "row health-help-ol"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "col-md-6 col-sm-6 col-xs-12"
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$t("home.health_intervention_desc")) + "\n          ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "###"
    }
  }, [_vm._v(_vm._s(_vm.$t("common.more")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "cutting-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "company-partner"
  }, [_c('h4', {
    staticClass: "title-md"
  }, [_c('a', {
    attrs: {
      "href": "###"
    }
  }, [_vm._v(_vm._s(_vm.$t("home.partner_organization"))), _c('em', [_vm._v("Partner Organization")])])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-container"
  }, [_c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "flexslider banner-box"
  }, [_c('ul', {
    staticClass: "slides"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../src/assets/images/5.png")
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../src/assets/images/web3-20.png")
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-md-offset-0 col-sm-offset-0 col-md-4 col-sm-4 col-xs-offset-2 col-xs-8 company-sign"
  }, [_c('img', {
    attrs: {
      "src": require("../../src/assets/images/6.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-md-4 col-sm-4 col-md-offset-0 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('img', {
    attrs: {
      "src": require("../../src/assets/images/2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "row partner-lists"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": require("../../src/assets/images/4.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7205aee6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 271
// module chunks = 1